import { render } from "./loaderPOS.vue?vue&type=template&id=1b62c4da&scoped=true"
const script = {}

import "./loaderPOS.vue?vue&type=style&index=0&id=1b62c4da&lang=scss&scoped=true"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b62c4da"]])

export default __exports__